module.exports = __webpack_public_path__ + "img/13.08016f2b.png";